import { Auth0Provider } from '@auth0/auth0-react';
import { theme } from '@zappyrent/hundop';
import { Suspense } from 'react';
import { ThemeProvider } from 'styled-components';

import { AppGlobalStyle } from './App.styles';
import { getLocaleFromUrl } from '../../helpers';
import '../../i18n';
import LoadingPage from '../../pages/LoadingPage';
import Router from '../Router';

const App = (): JSX.Element => {
  return (
    <>
      <AppGlobalStyle />
      <ThemeProvider theme={theme}>
        <Auth0Provider
          domain={process.env.REACT_APP_AUTH0_DOMAIN!}
          clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
          audience={process.env.REACT_APP_AUTH0_AUDIENCE}
          redirectUri={window.location.origin}
          cacheLocation={'localstorage'}
          scope={process.env.REACT_APP_AUTH0_SCOPE}
          locale={getLocaleFromUrl()}
        >
          <Suspense fallback={<LoadingPage title="Loading..." />}>
            <Router />
          </Suspense>
        </Auth0Provider>
      </ThemeProvider>
    </>
  );
};

export default App;
